export const sampleScheduleList = {
  meta: {
    count: 2016,
    page: 1,
    pagesize: 10,
    columns: [
      {
        key: 'title',
        title: ' Schedule Title',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'activity',
        title: 'Activity',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'assets',
        title: 'Assets',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'type',
        title: 'Schedule Type',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'startDate',
        title: 'Start Date',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      },
      {
        key: 'endDate',
        title: 'End Date',
        searchable: true,
        sortable: true,
        visible: true,
        type: 'string',
        options: []
      }
    ]
  },
  data: [
    {
      id: 1,
      title: 'PM Daily_Recurring_12Days',
      type: 'PM_Once_12days',
      activity: 'Recuring',
      assets: 'CPA04A1',
      startDate: '2022-12-10',
      endDate: '2022-12-10'
    },
    {
      id: 2,
      title: 'PM_BiMonth_12Days',
      type: 'PM_BiMonth_12days',
      activity: 'Relative Recuring',
      assets: 'CPA04A1',
      startDate: '2022-12-10',
      endDate: '2022-12-10'
    },
    {
      id: 3,
      title: 'PM Daily_Recurring_12Days',
      type: 'PM_Once_12days',
      activity: 'One Time',
      assets: 'OUN989',
      startDate: '2022-12-10',
      endDate: '2022-12-10'
    },
    {
      id: 4,
      title: 'PM Mothly_RelRecurring_2Mon',
      type: 'PM_Monthly_',
      activity: 'Recuring',
      assets: 'CPA04A1',
      startDate: '2022-12-10',
      endDate: '2022-12-10'
    }
  ]
};

export const types = {
  scheduleType: [
    {
      id: 1,
      type: 'PM_Monthly_'
    },
    {
      id: 2,
      type: 'PM_Once_12days'
    },
    {
      id: 3,
      type: 'PM_BiMonth_12days'
    },
    {
      id: 4,
      type: 'PM_Once_12days'
    }
  ],
  recurs: [
    {
      id: 1,
      recur: 'One Time'
    },
    {
      id: 2,
      recur: 'Relative Recurring'
    },
    {
      id: 3,
      recur: 'Recurring'
    }
  ]
};
